<template>
  <div class="alerts flex gap-20">
    <BaseButton @click="addAlert" class="add-alert"> הוספה </BaseButton>
    <div class="alert" :key="alert.promo" v-for="alert in getAlerts">
      <div class="text-continer flex gap-05">
        <img
          v-if="alert.imageUrl"
          class="alert-image-preview"
          :src="getAlertImageSrc(alert.imageUrl)"
        />
        <template v-else>
          <img
            class="icon"
            v-if="getIconSrc(alert.icon)"
            :src="getIconSrc(alert.icon)"
          />
          <span class="Heebo content">
            {{ alert.content }}
          </span>
        </template>
      </div>
      <BaseButton v-if="alert.editable" @click="editAlert(alert)">
        עריכה
      </BaseButton>
      <BaseButton v-if="alert.imageUrl" @click="editAutoClose(alert)">
         עריכה 
      </BaseButton>
      <BaseButton @click="clickRemove(alert)"> מחיקה </BaseButton>
      <span class="type"> סוג : {{ alert.type }}</span>
    </div>
    <EditAlertModal
      :saveOrEdit="textButtonInModal"
      :alert="currentAlert"
      :isEdit="isEdit"
      :customers="getCustomers"
      @exitModal="isOpenModal = false"
      @saveAlert="saveAlert"
      v-if="isOpenModal"
    >
    </EditAlertModal>
    <ConfirmDialog
      v-if="isConfirmDialog"
      :text="confirmDialogText"
      @confirm="confirmDialog"
      @deny="denyDialog"
    />
    <EditAutoCloseModal
      v-if="isAutoCloseModalOpen"
      :alert="autoCloseAlert"
      @exitModal="isAutoCloseModalOpen = false"
      @save="saveAutoClose"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BaseButton from "../helpers/BaseButton.vue";
import EditAlertModal from "../helpers/EditAlertModal.vue";
import ConfirmDialog from "../helpers/ConfirmDialog.vue";
import EditAutoCloseModal from "../helpers/EditAutoCloseModal.vue";
import { baseUrl } from "../../config";
export default {
  components: {
    BaseButton,
    EditAlertModal,
    ConfirmDialog,
    EditAutoCloseModal,
  },
  data() {
    return {
      isOpenModal: false,
      isConfirmDialog: false,
      confirmDialogType: null,
      confirmDialogText: null,
      textButtonInModal: null,
      isEdit:null,
      currentAlert: null,
      isAutoCloseModalOpen: false,
      autoCloseAlert: null,
    };
  },
  async mounted() {
    await this.$store.dispatch("Customers/getCustomers");
  },
  methods: {
    getIconSrc(icon) {
      if (icon) return `images/${icon}-icon.png`;
      else return;
    },
    getAlertImageSrc(imageUrl) {
      return `${baseUrl}/alert-images/${imageUrl}`;
    },
    editAlert(alert) {
      this.currentAlert = { ...alert };
      this.textButtonInModal = "שמור";
      this.isEdit = true;
      this.isOpenModal = true;
    },
    addAlert() {
      this.currentAlert = null;
      this.textButtonInModal = "הוסף";
      this.isEdit = false;
      this.isOpenModal = true;
    },
    async saveAlert(alert) {
      await this.$store.dispatch("Alert/saveAlert", alert);
      this.isOpenModal = false;
    },
    editAutoClose(alert) {
      this.autoCloseAlert = { ...alert };
      this.isAutoCloseModalOpen = true;
    },
    async saveAutoClose(payload) {
      const success = await this.$store.dispatch(
        "Alert/updateAlertAutoClose",
        payload
      );
      if (success) this.isAutoCloseModalOpen = false;
    },
    async removeAlert(alert) {
      await this.$store.dispatch("Alert/removeAlert", alert);
      this.isOpenModal = false;
    },
    async confirmDialog() {
      if (this.confirmDialogType === "remove") {
        await this.removeAlert(this.currentAlert.alert);
        this.isConfirmDialog = false;
      }
    },
    denyDialog() {
      this.currentAlert = null;
      this.isConfirmDialog = false;
    },
    clickRemove(alert) {
      this.currentAlert = { ...alert };
      this.isConfirmDialog = true;
      this.confirmDialogType = "remove";
      this.confirmDialogText = "האם אתה בטוח רוצה למחוק את הודעה זאת";
    },
  },
  computed: {
    ...mapGetters({
      getAlerts: "Alert/getAlertsPopups",
      getCustomers: "Customers/getCustomers",
    }),
  },
};
</script>

<style scoped lang="scss">
.text-continer {
  margin-bottom: 10px;
  color: white;
}
.content {
  width: 100%;
  font-size: $mediumTextSize;
}
.icon {
  width: 30px;
}
.alert-image-preview {
  max-width: 120px;
  max-height: 120px;
  object-fit: contain;
  border-radius: 8px;
}
.add-alert {
  width: 90%;
}
.alerts {
  padding: 10px;
  flex-direction: column;
}
.alert {
  width: 100%;
  padding: 10px;
  box-shadow: 1px 1px 1px #ffe6ad;
  border-radius: 20px;
  background: #393945;
  max-width: 600px;
}

.product-continer {
  margin-bottom: 10px;
}
button {
  margin-left: 10px;
}
.type {
  color: white;
}
</style>